<template>
  <div class="row buttons-with-margin">
    <div class="col-md-12">
      <div class="card">
        <div class="row">
          <div class="col-md-6">
            <div class="card-header">
              <h4 class="card-title">Boutiques</h4>
            </div>
            <div class="card-content">
              <button @click="$router.push({name: 'StoreAdd'})" class="btn btn-default btn-fill btn-wd">Ajouter</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  export default {
    components: {
      PPagination
    },
    data () {
      return {
        defaultPagination: 3,
        infoPagination: 5
      }
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/pages/Company/View.vue